import "./modules/common";
import VueApp from "~/Scripts/new/vueApp";
import ProductImagesWrapper from "~/Components/Product/ProductImagesWrapper.vue";
import ProductPricing from "~/Components/Product/ProductPricing.vue";
import EventInstances from "~/Components/Events/EventInstances.vue";

new VueApp( {
  name: "EventItem",

  components: {
    ProductImagesWrapper,
    EventInstances,
    ProductPricing
  },

  data: () => ( {
    selectedPricingSchedule: null,
    purchaseAllowed: false,
    userMessage: null,
    hasValidPricingSchedule: null,
    hasLocation: false,
    category: null
  } ),

  methods: {
    updatePurchaseAllowed ( val ) {
      this.purchaseAllowed = val;
    },
    updateUserMessage ( val ) {
      this.userMessage = val;
    },
    updateSchedule ( val ) {
      this.selectedPricingSchedule = val;
    },
    checkValidPricingSchedule ( val ) {
      this.hasValidPricingSchedule = val;
    },

    /**
     * The list of event instances has been updated
     * @param {object} config Configuration information about the list of loaded event instances
     */
    instanceConfigChanged ( config ) {
      if ( config ) {
        this.hasLocation = config.hasLocation;
        this.category = config.instanceType;
      } else {
        this.hasLocation = false;
        this.category = null;
      }
    }
  }
} );
